/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { App, App$inboundSchema } from "./app.js";
import { Meta, Meta$inboundSchema } from "./meta.js";

export type V1AppsGetAppResponseBody = {
  /**
   * Metadata object included in every API response. This provides context about the request and is essential for debugging, audit trails, and support inquiries. The `requestId` is particularly important when troubleshooting issues with the Teral support team.
   */
  meta: Meta;
  data: App;
};

/** @internal */
export const V1AppsGetAppResponseBody$inboundSchema: z.ZodType<
  V1AppsGetAppResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  meta: Meta$inboundSchema,
  data: App$inboundSchema,
});

export function v1AppsGetAppResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<V1AppsGetAppResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => V1AppsGetAppResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V1AppsGetAppResponseBody' from JSON`,
  );
}
